export default [
    {
        path: '/legal-content/:id',
        props: true,
        component: () => import('@/views/LegalContent/Version'),
    },
    {
        path: '/legal-content',
        props: true,
        component: () => import('@/views/LegalContent'),
    },
];
